import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from '../components/layout/Layout';
import PageTransition from '../motion/PageTransition';
import { refreshScrollTrigger } from '../motion/gsapSetup';
import Home from '../pages/Home';
import Portfolio from '../pages/Portfolio';
import Interiors from '../pages/Interiors';
import BlogListing from '../pages/BlogListing';
import SingleProject from '../pages/SingleProject';
import SinglePost from '../pages/SinglePost';

const AnimatedRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
      if (window.__lenis) {
        window.__lenis.scrollTo(0, { immediate: true });
      }
    }
    const timer = setTimeout(() => refreshScrollTrigger(), 120);
    return () => clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <PageTransition>
              <Home />
            </PageTransition>
          }
        />
        <Route
          path="/portfolio"
          element={
            <PageTransition>
              <Portfolio />
            </PageTransition>
          }
        />
        <Route
          path="/interiors"
          element={
            <PageTransition>
              <Interiors />
            </PageTransition>
          }
        />
        <Route
          path="/blog"
          element={
            <PageTransition>
              <BlogListing />
            </PageTransition>
          }
        />
        <Route
          path="/project/:id"
          element={
            <PageTransition>
              <SingleProject />
            </PageTransition>
          }
        />
        <Route
          path="/blog/:id"
          element={
            <PageTransition>
              <SinglePost />
            </PageTransition>
          }
        />
      </Routes>
    </AnimatePresence>
  );
};

const AppRouter = () => (
  <BrowserRouter>
    <Layout>
      <AnimatedRoutes />
    </Layout>
  </BrowserRouter>
);

export default AppRouter;
